var initDnGallery = function(gallerySelector, imageSelector, urlHash, openSelector) {

    var galleryItems = [];

    var initGalleryItems = function (gallerySelector, imageSelector) {
        var items = [];

        $(gallerySelector + ' ' + imageSelector).each(function () {
            item = {
                src: $(this).attr('data-src'),
                w: 0,
                h: 0,
                slug: $(this).attr('data-slug'),
                pid: $(this).attr('data-pid')
            };

            items.push(item);
        });

        galleryItems = items;
    };

    var initGalleryItemsOnClick = function () {
        $(gallerySelector + ' ' + imageSelector).each(function (i) {
            $(this).click(function (e) {
                e.preventDefault();
                openGallery(galleryItems, i);
            });
        });
    };

    var initGalleryItemsOnClickSelector = function (openSelector) {
        if (typeof(index) != "openSelector" && $(openSelector).length) {
            $(openSelector).click(function (e) {
                e.preventDefault();
                openGallery(galleryItems, 0);
            });
        }
    };

    var initGalleryByHashParams = function (hashParams) {
        if (hashParams.pid && hashParams.gid) {
            openGallery(galleryItems, hashParams.pid - 1);
        }
    };

    var openGallery = function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        // set options
        var options = {
            index: typeof(index) != "undefined" ? index : 0,
            arrowKeys: true,
            closeElClasses: ['ui', 'top-bar', 'caption', 'zoom-wrap', 'item'],
            clickToCloseNonZoomable: false,
            bgOpacity: 0.95,
            zoomEl: false,
            galleryPIDs: true,
            tapToToggleControls: false,
            adminMenu: true,
            hideAnimationDuration:0,
            showAnimationDuration:0
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        // dynamically load width and height of added images
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                var img = new Image();
                img.onload = function () {
                    item.w = this.width;
                    item.h = this.height;
                    gallery.updateSize(true);
                };
                img.src = item.src;
            }
        });

        // call after image has loaded - analytics and google analytics
        gallery.listen('afterChange', function () {
            updatePidInSwiper(gallery.currItem.pid);
        });

        gallery.listen('destroy', function () {
        });

        gallery.init();
    };

    var parseHash = function (urlHash) {
        var hash = urlHash.substring(1),
            params = {};

        if (hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    initGalleryItems(gallerySelector, imageSelector);
    initGalleryItemsOnClick(galleryItems);
    initGalleryByHashParams(parseHash(urlHash));
    initGalleryItemsOnClickSelector(openSelector);
};

$(document).ready(function() {
    if ($('.dnSingleGalleryGrid').length) {
        initDnGallery('.dnSingleGalleryGrid', 'a', window.location.hash);
    }
});